import { IToastInput, toastStore } from "src/stores/toast-store";

export const ToastStatus = {
    Info: "info",
    Success: "success",
    Error: "error",
    Warning: "warning",
} as const;
export type ToastStatus = (typeof ToastStatus)[keyof typeof ToastStatus];

type IToastOption = Omit<IToastInput, "duration"> & {
    duration?: number;
};

const wfToast = ({ duration = 3000, ...toastProps }: IToastOption) => {
    return toastStore.push({ ...toastProps, duration });
};

export const useWfToast = () => wfToast;
